<template>
  <div class="d-flex">
    <div :class="`wd-100p`">
      <Cascader
        filterable
        v-model="cascaderSelected"
        :options="departs"
        @change="departIDChange"
        :props="{ checkStrictly: checkStrictly }"
        :transfer="true"
        :disabled="disabled"
        clearable
        size="mini"
        style="width:100%"
      ></Cascader>
    </div>
  </div>
</template>
<script>
import { request } from "@/api/all";
var LTT = require("list-to-tree");
import "element-ui/lib/theme-chalk/index.css";
import { Cascader } from "element-ui";
export default {
  components: {
    Cascader
  },
  name: "locTypeCascader",
  props: {
    id: {
      type: Number,
      default: () => 0
    },
    checkStrictly: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      departs: [],
      departsFlat: [],
      cascaderSelected: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      //GetDepartTreeData().

      request({
        api: { method: "GET", url: "Hr/GetDepartTreeData" },
        store: this.$store
      }).then(res => {
        let dataTypes = res.data.departs;
        this.departsFlat = dataTypes;
        var ltt = new LTT(dataTypes, {
          key_id: "id",
          key_parent: "parentId",
          key_child: "children"
        });
        this.departs = ltt.GetTree();

        this.cascaderSelected = [];
        if (this.id > 0) {
          //console.log(this.cascaderSelected);
          this.cascaderModelRecursive(this.departsFlat, this.id);
          //console.log(this.cascaderSelected);
          this.cascaderSelected = this.cascaderSelected.reverse();
          //console.log(this.cascaderSelected);
        } else this.cascaderSelected = [];
      });
    },
    cascaderModelRecursive(data, cid) {
      this.cascaderSelected.push(cid);
      let pid = data.filter(d => d.id == cid)[0].parentId;
      if (pid > 0) {
        this.cascaderModelRecursive(data, pid);
      }
    },
    departIDChange(value, selectedData) {
      let _id =
        value[value.length - 1] != undefined ? value[value.length - 1] : null;
      this.$emit("input", _id);
      this.$emit("on-change", _id);
    }
  }
};
</script>
